import { IMAGE_FORMAT_WEBP, IMAGE_FORMAT_PNG } from '../imageFormat.constants';

export const DEFAULT_IMAGE_FORMAT = IMAGE_FORMAT_WEBP;

export const TRANSPARENT_IMAGE_FORMAT = IMAGE_FORMAT_PNG;
